import React from "react";
import { DwsimProDialogType } from "../../swagger-clients/s365-admin-panel-clients.service";
import { getDwsimProDialogTypeLabel } from "./dwsim-pro-dialog-type.utilities";

type DwsimProDialogTypeDisplayProps = {
    value?: DwsimProDialogType;
}

export const DwsimProDialogTypeDisplay: React.FC<DwsimProDialogTypeDisplayProps> = (props) => {


    return  <small style={{ backgroundColor: "lightblue", padding: "3px", borderRadius: "4px" }}>
            {getDwsimProDialogTypeLabel(props.value)}</small>
    
}


